export const filterTags = [
  {
    filter: 'budget',
    tags: ['Tight', 'Normal', 'Healthy'],
    activeFilterIdx: [],
  },
  {
    filter: 'location',
    tags: [
      'Brooklyn',
      'Queens',
      'Manhattan',
      'Bronx',
      'Staten Island',
      'Long Island',
      'Upstate New York',
      'New Jersey',
      'Connecticut',
      'Massachusetts',
      'Vermont',
      'Pennsylvania',
      'Hawai',
    ],
    activeFilterIdx: [],
  },
  {
    filter: 'capacity',
    tags: ['0-100', '100-200', 'Over-200'],
    activeFilterIdx: [],
  },
  {
    filter: 'indoor-outdoor',
    tags: ['Covered outdoor', 'Uncovered outdoor', 'Indoor'],
    activeFilterIdx: [],
  },
  {
    filter: 'other',
    tags: ['Rooftop', 'Skyline views', 'Waterfront', 'Bridal suite'],
    activeFilterIdx: [],
  },
];
